/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
// angular native
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

// External Module Dependencies
/*import { KpmgTaxCoreModule,AsyncSessionStorageService,AsyncLocalStorageService } from '@kpmg-tax/core';*/
// custom components
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ClientShellModule } from './client-shell';
import { CustomPreloadingStrategy } from './services/custom-preloading-strategy';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InterceptorProviders } from './core/interceptors/interceptor-providers';
import { CoreModule } from './core/core.module';
import { CommonService } from './services/common.service';
import { PowerBIService  } from './services/powerbi.service';
import { AppConfig } from './app.config';
import { EnvSettingsService } from './core/services/env-settings.service';
import { CopyrightModule } from './copyright/copyright.module';
import { ThemeLoaderModule } from '@kpmg-ux/ngx-tax-design-system';

import { MsalInterceptor, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
// third party libraries

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule ,
    SharedModule,
    ClientShellModule,
    CopyrightModule,
    CoreModule,
    ThemeLoaderModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MsalModule
  ],
  providers: [
    CustomPreloadingStrategy,
    CommonService,
    PowerBIService,
    AppConfig,
    EnvSettingsService,
    MsalService,
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (appConfigProvider: EnvSettingsService) => {
        return () => appConfigProvider.load();
      },
      multi: true,
      deps: [EnvSettingsService]
    },
    InterceptorProviders
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
